import { AfterContentInit, Component, Input, OnChanges } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { createForm, FormType, subformComponentProviders } from 'ngx-sub-form';
import { FullEvacIPP, InternalPressureProfileType } from '../../models/internal-pressure-profile.model';
import { UserUnitsModel } from 'src/app/core/components/user-units/user-units.model';
import { unitsLib } from 'src/app/core/services/unit-library';
import { GetValueFromPpg } from 'src/app/perivis/shared/helpers/units.helper';

interface FullEvacIppForm {
  type: InternalPressureProfileType.FULLEVAC
}

@Component({
    selector: 'app-full-evac-ipp',
    template: `
      <div class="flex flex-col space-y-2">
        <app-uom-input
          label="Fluid Level"
          [inputDisabled]="true"
          [default]="currentString.shoeMd.toFixed(3)"
          [unitLabel]="lengthLabel"
        />
        <app-uom-input
          label="Fluid Density"
          [inputDisabled]="true"
          [default]="airDensity"
          [unitLabel]="densityLabel"
        />
      </div>
    `,
    providers: subformComponentProviders(FullEvacIppComponent),
    standalone: false
})
export class FullEvacIppComponent implements OnChanges, AfterContentInit {
  @Input() currentString: any;
  @Input() userUnits: UserUnitsModel;

  public densityLabel: string;
  public lengthLabel: string;
  public airDensity: number;

  ngOnChanges(): void {
    this.lengthLabel = this.userUnits.longLengths;
    this.densityLabel = unitsLib[this.userUnits.density].symbol;
    this.airDensity = GetValueFromPpg(0.01001084, this.densityLabel);
  }

  public form = createForm<FullEvacIPP, FullEvacIppForm>(this, {
    formType: FormType.SUB,
    formControls: {
      type: new UntypedFormControl(InternalPressureProfileType.FULLEVAC)
    },
    toFormGroup: (obj: FullEvacIPP | null): FullEvacIppForm | null => {
      if (!obj) {
        return null;
      }

      return {
        type: InternalPressureProfileType.FULLEVAC
      }
    },
    fromFormGroup: (formValue: FullEvacIppForm): FullEvacIPP | null => {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { type, ...commonValues} = formValue;

      return { type: InternalPressureProfileType.FULLEVAC, ...commonValues }
    }
  });

  ngAfterContentInit(): void {
    this.form.formGroup.controls.type.setValue(InternalPressureProfileType.FULLEVAC);
  }
}
